import { Desktop, LargeMobile, SmallMobile } from 'styles/MediaQueries';
import BlankPerson from 'images/ContainerIcons/BlankPerson.svg';
import MainLayout from 'components/component_lib/MainLayout';
import React from 'react';

const headerContainerStyles = {
  marginBottom: '2rem'
};

const headerStyles = {
  fontSize: '2rem',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '1rem',

  [SmallMobile]: {
    fontSize: '1.75rem'
  }
};

const ctaContainerStyles = {
  [Desktop]: {
    maxWidth: '20rem',
    margin: 'auto'
  }
};

const additionalContentStyle = {
  margin: '2rem auto 0 auto',
  width: '100%',

  [LargeMobile]: {
    margin: '2rem auto 0 auto'
  },

  [SmallMobile]: {
    margin: '1.5rem auto 0 auto'
  },

  [Desktop]: {
    margin: '2rem auto 0 auto'
  }
};

const subHeaderDefaultStyle = {
  [Desktop]: {
    maxWidth: '20rem',
    margin: 'auto'
  }
};

function AuthLayout({ children, title, subTitle, subHeaderStyles = {} }) {
  return (
    <MainLayout
      icon={<BlankPerson />}
      additionalContentStyle={additionalContentStyle}
    >
      <div css={{ width: '100%' }}>
        <div css={headerContainerStyles}>
          <h1 css={headerStyles}>{title}</h1>
          <div css={[subHeaderDefaultStyle, subHeaderStyles]}>{subTitle}</div>
        </div>

        <div css={ctaContainerStyles}>{children}</div>
      </div>
    </MainLayout>
  );
}

export default AuthLayout;
